import {DataObjectId} from 'yougile-model'
import {logger} from 'yougile-util'
import {Backend} from '../../common/backend'
import {globals} from '../extensions/globals-base'

export class ArchiveClient {
  public static add(key: string, list: DataObjectId[]) {
    Backend.postJSON('/data/archive/add', {
      key,
      companyId: globals.getCompanyId(),
      list
    })
      .then((res: any) => {
        logger.log(res)
      })
      .catch(error => {
        logger.error(error)
      })
  }

  public static restore(key: string, name: string, onlyIds?: DataObjectId[]) {
    Backend.postJSON('/data/archive/restore', {
      key,
      companyId: globals.getCompanyId(),
      name,
      onlyIds
    })
      .then((res: any) => {
        logger.log(res)
      })
      .catch(error => {
        logger.error(error)
      })
  }
}
